import { render, staticRenderFns } from "./AdminMessageView.vue?vue&type=template&id=1d84648e&scoped=true"
import script from "./AdminMessageView.vue?vue&type=script&lang=js"
export * from "./AdminMessageView.vue?vue&type=script&lang=js"
import style0 from "./AdminMessageView.vue?vue&type=style&index=0&id=1d84648e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84648e",
  null
  
)

export default component.exports